import React from 'react'
import cn from 'classnames'
import { isMobileMediaQuery } from 'lib/theme'
import dynamic from 'next/dynamic'
import { StateResultsProvided } from 'react-instantsearch-core'
import { connectStateResults } from 'react-instantsearch-dom'
import { useMediaQuery } from 'react-responsive'

import useFeatureFlags from 'hooks/useFeatureFlags'

import styles from './WithFilter.module.css'

const FiltersModal = dynamic(() => import('./FiltersModal'))
const Filters = dynamic(() => import('components/UI/Filters/Filters'))

const FiltersPanel = ({ hide }: { hide: boolean }) => (
  <div className={cn(styles.filtersPanel, { [styles.hide]: hide })}>
    <Filters />
  </div>
)

export type WithFilterProps = {
  children: JSX.Element
} & StateResultsProvided

const WithFilter = ({
  children,
  searchResults,
}: WithFilterProps): JSX.Element => {
  const { searchFilter: searchFilterFeatureFlag } = useFeatureFlags()
  const isMobile = useMediaQuery(isMobileMediaQuery)

  if (!searchFilterFeatureFlag) {
    return children
  }

  const filtersAvailable =
    !!searchResults?.disjunctiveFacets?.length ||
    searchResults?.hierarchicalFacets.some((facets) => facets?.data)

  const hideFilters = !searchResults?.nbHits || !filtersAvailable

  const FiltersComponent = isMobile ? FiltersModal : FiltersPanel

  return (
    <div className={styles.wrapper}>
      <FiltersComponent hide={hideFilters} />

      <div className={styles.results}>{children}</div>
    </div>
  )
}

export default connectStateResults(WithFilter)
